const DIE_KASUS = [
    {
        name: 'nominative',
        uid: '0'
    },
    {
        name: 'accusative',
        uid: '1'
    },
    {
        name: 'dative',
        uid: '2'
    },
    {
        name: 'genitive',
        uid: '3'
    }
];

export default DIE_KASUS;


/** WEBPACK FOOTER **
 ** ./app/data/kasus.js
 **/